var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:_vm.classList,style:(_vm.rowStyle),attrs:{"data-index":_vm.rowIndex},on:{"click":_vm.clickHandle}},[_c('GridCellGroup',{attrs:{"rowData":_vm.rowData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }